import { render, staticRenderFns } from "./Line-Item-V2.vue?vue&type=template&id=e522eb94"
import script from "./Line-Item-V2.vue?vue&type=script&lang=js"
export * from "./Line-Item-V2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports